import { ArchiveArrowUpIcon } from './ArchiveArrowUpIcon';

/**
 * author: frankgrinaert
 * id 43E8F715-D3DB-4CAA-9355-88E22C7E4D28
 * name archive-arrow-up
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-arrow-up.svg
 * tags
 */
export const ThisSideUpIcon = ArchiveArrowUpIcon;
export default ThisSideUpIcon